// import Technology from '@/components/Technology';
import dynamic from 'next/dynamic';
import Layout from '@/components/Layout';
// const Layout = dynamic(()=> import('@/components/Layout'))

const Technology = dynamic(()=> import('@/components/Technology'))
Technology.getLayout = function getLayout(page) {
    return (
        <Layout webViewMobile={true} web='p-technology' >{page}</Layout>
    );
};

export async function getServerSideProps(context) {
    const UA = context.req.headers['user-agent'];
    const isMobile = Boolean(UA.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
    ));
    try {
        const res = await fetch(`${process.env.NEXT_PUBLIC_API_SERVER_URL}/app/feature_tech/get-list-feature_tech`, {
            headers: {
                'Content-Type': 'application/json',
                locale: context.locale

            }
        });
        const data = await res.json();
        if (!data || data.code !== 200) {
            return {
                notFound: true,
            };
        }
        return {
            props: { ...data.data, sign: context.locale }, // will be passed to the page component as props
        };
    } catch (error) {
        console.log("rrrrrrrrrrrrrrrrrrrrrrrrrrrrrr", error);
        return {
            notFound: true,
        };
    }

}

export default Technology;


